import PermissionChecklist from '../../PermissionChecklist';

const EditUserPermissionsForm = [
  {
    label: '',
    keyName: 'permissions',
    Component: PermissionChecklist,
  },
];

export default EditUserPermissionsForm;
